// @flow
/**
 * @module Actions/HealthCheck
 * @desc Health Check Actions
 */
import { createActions } from 'redux-actions';

import { ActionTypes } from 'constants/index';

export const {
  startHealthCheck,
  getHealthChecks,
  getHealthCheckMetrics,
  getHealthCheckReport,
  getLastHealthCheckForLocation,
} = createActions({
  [ActionTypes.START_HEALTH_CHECK]: params => params,
  [ActionTypes.GET_HEALTH_CHECKS]: params => params,
  [ActionTypes.GET_HEALTH_CHECK_METRICS]: params => params,
  [ActionTypes.GET_HEALTH_CHECK_REPORT]: (reportId, meta = {}) => ({ reportId, meta }),
  [ActionTypes.GET_LAST_HEALTH_CHECK_FOR_LOCATION]: locationId => ({ locationId }),
});
